import { useParams } from "@solidjs/router";
import { useSFetch } from "../hooks/sfetch";
import { createSignal, onMount } from "solid-js";
import { Grant } from "./MyGrants";
import { Command } from "./MyCommands";
import { For } from "solid-js";
import { Show } from "solid-js";
import { useToast } from "../components/MessageBox";
import Text from "../components/Text";
import { useTranslation } from "../hooks/useTranslation";
import AddonState from "../components/AddonState";

export function Bot() {

    const params = useParams();
    const sfetch = useSFetch();
    const toast = useToast();
    const { t } = useTranslation();
    const [grant, setGrant] = createSignal<Grant>();
    const [botId, setBotId] = createSignal<string>();
    const [botName, setBotName] = createSignal<string>();
    const [commands, setCommands] = createSignal<Command[]>([]);
    const [selectedCommandId, setSelectedCommandId] = createSignal<string | undefined>(undefined);
    const [postfix, setPostfix] = createSignal<string | undefined>("");

    onMount(async () => {
        try {
            const response = await sfetch(`/api/GrantedUsers/GetMyBots`);
            const data = response;
            const grant = data.value.find((g: Grant) => g.id === params.id);
            setGrant(grant);
            setBotId(grant?.botId);

            const botNameResponse = await sfetch(`/api/GrantedUsers/GetNameOfBot/${grant?.botId}`);
            setBotName(botNameResponse.value);

            if (!grant) {
                toast?.error(t("BOT_GRANT_NOT_FOUND"));
            }

            await sfetch('/api/GrantedUsers/GetGrantedCommandPrefabsForBot/' + grant?.botId)
                .then(data => setCommands(data.value));

        } catch (error) {
            toast?.error(t("BOT_FETCH_ERROR"));
        }
    });

    function exec() {
        if (!selectedCommandId()) {
            toast?.error(t("BOT_NO_COMMAND_SELECTED"));
            return;
        }

        sfetch(`/api/Command/ExecuteCommand`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                prefabId: selectedCommandId(),
                postfix: postfix()
            })
        }).then(data => {
            if (data.status == 200) {
                toast?.info(t("BOT_COMMAND_EXECUTED"));
            }
            else {
                toast?.error(t("BOT_COMMAND_EXEC_ERROR"));
            }
        });
    }

    function currentCommand() {
        return commands().find(x => x.id == selectedCommandId())!;
    }

    return (
        <div class="dashboard-page">
            <div class="h wrap alignstart">
                <div class="fcard">
                    <div class="h">
                        <img class="minecraft-avatar" style={{ height: "4.8rem" }} src={`https://mineskin.eu/helm/${botName()}`} alt="" />
                        <div class="v">
                            <div class="h alignstart">
                                <h4 class="nomargin">{botName()}</h4>
                                <div class="minicard"><Text val="LEVEL" />: {grant()?.level}</div>
                            </div>
                            <div class="hline"></div>
                            <span class="gray">{botId() ?? 'na'}</span>
                        </div>
                    </div>
                </div>
                <Show when={botId()}>
                    <AddonState id={botId()} />
                </Show>
            </div>
            <div class="fcard">
                <h2><i class="fa-solid fa-terminal"></i> <Text val="GRANTEDCOMMANDS"></Text></h2>
                <select onChange={(e) => {
                    setSelectedCommandId((e.target as HTMLSelectElement).value);
                    setPostfix("");
                }} value={selectedCommandId()}>
                    <option value=""><Text val="SELECTCOMMAND"></Text></option>
                    <For each={commands() ?? []}>
                        {(command) => (
                            <option value={command.id}>
                                {command.name !== "" ? command.name : command.template}
                            </option>
                        )}
                    </For>
                </select>
                <Show when={selectedCommandId()}>
                    <h3>{currentCommand().name}</h3>
                    <span><Text val="PREVIEW" /></span>
                    <div class="row">
                        <p class="commandtext">{currentCommand().template + (postfix() ? ` ${postfix()}` : "")}</p>
                        <button class="commandexec" onClick={exec}><Text val="EXECUTE"></Text></button>
                    </div>
                    <Show when={currentCommand().onlyPrefix}>
                        <input type="text" placeholder={t("BOT_POSTFIX_PLACEHOLDER")} value={postfix()} onChange={(e) => setPostfix((e.target as HTMLInputElement).value)} onKeyUp={(e) => setPostfix((e.target as HTMLInputElement).value)} />
                    </Show>
                </Show>
            </div>
        </div>
    );
}